import React, { useCallback, useEffect } from 'react';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { TerminalPayment } from '@yme/assets/icons';
import { ModalWindowFooter } from '@yme/atoms/modal-footer';
import { MD_MODAL, StaticModalWindow } from '@yme/atoms/modal-window';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { COOKIE_ORDER_NUMBER_KEY } from '@yme/common/constants';
import { COOKIE_CART_ID_KEY } from '@yme/common/redux/cart/constants';
import { getCartId } from '@yme/common/redux/cart/selectors';
import { payOnlineByTerminal, } from '@yme/components/CheckoutForm/PaymentForm/PaymentOptions/TerminalOnline';
import { resetPaymentErrors } from '@yme/components/CheckoutForm/PaymentForm/PaymentOptions/TerminalOnline/redux/actions';
import { getIsTerminalResultSuccess } from '@yme/components/CheckoutForm/PaymentForm/PaymentOptions/TerminalOnline/redux/selectors';
import { getOrderReviewState } from '@yme/components/CheckoutForm/redux/selectors';
import { useWindowSize } from '@yme/hooks/index';
import { useSessionStorage } from '@yme/hooks/useSessionStorage';
import { setIsModalHide } from '@yme/modals/actions';
import { getModalData } from '@yme/modals/selectors';
import { getCommercetoolsProjectKey, getRootLang, getRTL } from '@yme/selectors/common';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { INDENT } from '@yme/tokens/sizes';
import { FlexWrapperStyled, RegularTextLevel3Styled } from './';
const KIOSK_TERMINAL_PAYLOAD = 'kioskTerminalPayload';
const ModalFooter = ({ description }) => {
    const dispatch = useDispatch();
    const { isInfiniteDesktopView } = useWindowSize();
    const hideModalHandler = useCallback(() => {
        dispatch(setIsModalHide());
    }, [dispatch]);
    return (React.createElement(ModalWindowFooter, { isSubmitButtonFullWidth: !isInfiniteDesktopView, isHiddenBorder: true, onHide: hideModalHandler },
        React.createElement(RegularTextLevel3Styled, { color: colorCoreBlack300 }, description)));
};
export function TerminalPaymentModal() {
    const isRightToLeft = useSelector(getRTL);
    const { title, description, cb } = useSelector(getModalData);
    const cartId = useSelector(getCartId);
    const projectKey = useSelector(getCommercetoolsProjectKey);
    const locale = useSelector(getRootLang);
    const isSuccess = useSelector(getIsTerminalResultSuccess);
    const { orderNumber } = useSelector(getOrderReviewState);
    const [getSessionStorageItem] = useSessionStorage(KIOSK_TERMINAL_PAYLOAD);
    const { terminalPOIID, saleID } = getSessionStorageItem();
    const dispatch = useDispatch();
    const cartIdFromCookies = Cookies.get(COOKIE_CART_ID_KEY) || '';
    const orderNumberCookies = (Cookies.get(COOKIE_ORDER_NUMBER_KEY) || orderNumber?.toString()) ?? '';
    const hideModalHandler = useCallback(() => {
        dispatch(setIsModalHide());
    }, [dispatch]);
    useEffect(() => {
        dispatch(resetPaymentErrors());
    }, [dispatch]);
    useEffect(() => {
        (async () => {
            dispatch(payOnlineByTerminal({
                cartId: cartId || cartIdFromCookies,
                projectKey,
                locale,
                orderNumber: orderNumberCookies,
                terminalPOIID,
                saleID,
            }));
        })();
    }, [
        cartId,
        cartIdFromCookies,
        dispatch,
        locale,
        orderNumber,
        orderNumberCookies,
        projectKey,
        saleID,
        terminalPOIID,
    ]);
    useEffect(() => {
        if (isSuccess) {
            hideModalHandler();
            cb?.();
        }
    }, [cb, hideModalHandler, isSuccess]);
    return (React.createElement(StaticModalWindow, { hasCloseButton: false, isClickOutsideDisabled: true, onHide: hideModalHandler, staticModalSize: MD_MODAL, title: title, minHeight: "auto", isRightToLeft: isRightToLeft, footerComponent: React.createElement(ModalFooter, { description: description }) },
        React.createElement(FlexWrapperStyled, { justifyContent: "center", isFullWidth: true, pb: INDENT.sm },
            React.createElement(SVGIcon, { type: TerminalPayment, size: ICON_SIZE.xxxxxl }))));
}
